// src/components/PrivateRoute.js
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token"); // or use cookies/session
  return token ? children : <Navigate to="/auth/login" replace />;
};

export default PrivateRoute;
